// POM-6279 P5 — relay orders delivered by vendor API (Quello) or by fax (RingCentral).
//
// Every lookup here FALLS BACK TO THE RAW VALUE. Core can add an enum member before the portal
// ships a label for it; rendering the value as received is honest, where a blank cell, a throw or
// a guessed label is not.

// Mirrors core's `enum RelayDeliveryMethod` (graphql/relay/typeDefs.ts) by name.
export const RELAY_DELIVERY_METHOD = {
  API: 'API',
  FAX: 'FAX',
};

const RELAY_DELIVERY_METHOD_LABELS = {
  [RELAY_DELIVERY_METHOD.API]: 'API',
  [RELAY_DELIVERY_METHOD.FAX]: 'Fax',
};

export const relayDeliveryMethodLabel = (value) => {
  if (value === undefined || value === null || value === '') return 'N/A';

  return RELAY_DELIVERY_METHOD_LABELS[value] ?? String(value);
};

// The relay queue's "Relay Type" filter, in the { value, label } shape MultiPracticeSelectField
// takes. Values are the enum core accepts in RelayOrdersFilter.deliveryMethods.
export const RELAY_DELIVERY_METHOD_OPTIONS = Object.values(RELAY_DELIVERY_METHOD).map((value) => ({
  value,
  label: relayDeliveryMethodLabel(value),
}));

// POM-6279: the relay queue's statuses (core's RelayQueueStatus); PENDING reads as "In Process".
export const RELAY_STATUS = {
  PENDING: 'PENDING',
  TRANSFERRED: 'TRANSFERRED',
};

const RELAY_STATUS_LABELS = {
  [RELAY_STATUS.PENDING]: 'In Process',
  [RELAY_STATUS.TRANSFERRED]: 'Transferred',
};

export const relayStatusLabel = (value) => RELAY_STATUS_LABELS[value] ?? value;

export const RELAY_STATUS_OPTIONS = Object.values(RELAY_STATUS).map((value) => ({
  value,
  label: relayStatusLabel(value),
}));

// Friendly names for the keys a FAX relay writes into relay_order_event.event_data. Any key not
// listed here is rendered raw by the timeline.
const RELAY_EVENT_DATA_KEY_LABELS = {
  deliveryMethod: 'Relay Type',
  documentCount: 'Documents',
  previousTransmissionReference: 'Previous Transmission Ref',
  confirmedResend: 'Resend Confirmed',
  faxMayHaveBeenSent: 'Fax May Have Been Sent',
};

/** The friendly label for an event-data key, or null when it has none (the caller keeps it raw). */
export const relayEventDataKeyLabel = (key) => RELAY_EVENT_DATA_KEY_LABELS[key] ?? null;

export const formatRelayEventDataValue = (key, value) => {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (key === 'deliveryMethod') return relayDeliveryMethodLabel(value);

  return typeof value === 'object' && value !== null ? JSON.stringify(value) : String(value);
};
